import * as React from 'react'
import { DefaultSeo, LogoJsonLd } from 'next-seo'

import defaultSeoConfig from 'utils/default-seo-config'

export default function DefaultSEO() {
    return (
        <>
            <DefaultSeo {...defaultSeoConfig} />
            <LogoJsonLd
                logo="https://storage.googleapis.com/devv-public/brand-assets/favicon/apple-touch-icon.png"
                url="https://devv.it/"
            />
        </>
    )
}
